export default __webpack_public_path__ + "static/media/defaultGalleryIcon.3331145e.svg";